'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _Row = require('web-makeup/dist/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('web-makeup/dist/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Input = require('web-makeup/dist/Input');

var _Input2 = _interopRequireDefault(_Input);

var _style = require('../style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

var FormContainer = (0, _styledComponents2.default)(_Row2.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.5rem 0;\n  label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.75rem;\n  }\n"], ["\n  margin: 0.5rem 0;\n  label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.75rem;\n  }\n"])));
var CardIcon = (0, _styledComponents2.default)(_CloudinaryImage2.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 16px;\n  top: 33px;\n  z-index: 2;\n"], ["\n  position: absolute;\n  right: 16px;\n  top: 33px;\n  z-index: 2;\n"])));
var DisabledInput = (0, _styledComponents2.default)(_Input2.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &.ant-input-disabled {\n    background-color: ", ";\n    color: ", ";\n    border: transparent;\n  }\n"], ["\n  &.ant-input-disabled {\n    background-color: ", ";\n    color: ", ";\n    border: transparent;\n  }\n"])), _style.COLOR_GANDALF, _style.COLOR_MIDNIGHT);
var CreditCard = function CreditCard(_a) {
    var card = _a.card;
    var last4Digits = card.last4Digits,
        cardBrand = card.cardBrand,
        expiryMonth = card.expiryMonth,
        expiryYear = card.expiryYear;
    var brandIconMap = {
        Visa: 'visa',
        MasterCard: 'mastercard',
        'American Express': 'amex'
    };
    var icon = brandIconMap[cardBrand];
    var expiry = expiryMonth + "/" + expiryYear.toString().substring(2, 4);
    return React.createElement(FormContainer, { type: "flex", gutter: 10 }, React.createElement(_Col2.default, { xs: 16 }, icon && React.createElement(CardIcon, { useSourceFormat: true, source: { id: "-homepage-icons/-footer/icon-" + icon, type: 'upload' } }), React.createElement("label", { htmlFor: "credit-card-number" }, React.createElement(_reactIntl.FormattedMessage, { id: "Number" })), React.createElement(DisabledInput, { disabled: true, size: "large", value: '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ' + last4Digits })), React.createElement(_Col2.default, { xs: 4 }, React.createElement("label", { htmlFor: "expiry-date" }, React.createElement(_reactIntl.FormattedMessage, { id: "Expiry" })), React.createElement(DisabledInput, { disabled: true, size: "large", value: expiry })), React.createElement(_Col2.default, { xs: 4 }, React.createElement("label", { htmlFor: "cvc-cvs" }, React.createElement(_reactIntl.FormattedMessage, { id: "CVC" })), React.createElement(DisabledInput, { disabled: true, size: "large", value: '\u2022\u2022\u2022' })));
};
exports.default = CreditCard;

var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CreditCard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/CreditCard/CreditCard.js
// module id = 1941
// module chunks = 0